(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.abortController = null;
    }

    connectedCallback() {
      this.productUrl = this.dataset.productUrl;
      this.sectionId = this.dataset.section;
      this.changeURL = this.dataset.changeUrl === 'true';
      this.addButton = document.querySelector(`#product-form-${this.sectionId} [name="add"]`);

      this.addEventListener('change', (event) => {
        const optionValues = this.selectedOptionValues.join(',');
        const requestUrl = `${this.productUrl}?section_id=${this.sectionId}&option_values=${optionValues}`;
        this.renderProductInfo(requestUrl, this.productUrl, this.sectionId, this.changeURL);
      });
    }

    get selectedOptionValues() {
      return Array.from(this.querySelectorAll('.variant-block input:checked')).map(
        ({ dataset }) => dataset.optionValueId
      );
    }

    async renderProductInfo(requestUrl, productUrl, sectionId, changeURL) {
      if (this.abortController) {
        this.abortController.abort();
      }

      this.abortController = new AbortController();
      this.addButton.disabled = true;

      try {
        const response = await fetch(requestUrl, {
          signal: this.abortController.signal,
        });
        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const variantElement = html.querySelector('variant-selects [data-selected-variant]');
        const variantData = variantElement ? variantElement.textContent : null;
        const variant = variantData ? JSON.parse(variantData) : null;
        // console.log('variant', variant);

        if (!variant) {
          this.addBtnText(true, window.variantStrings.unavailable, this.addButton);
          return;
        }

        this.updateVariantInputs(variant?.id);
        this.addBtnText(!variant.available, window.variantStrings.soldOut, this.addButton);

        if (changeURL) {
          const newUrl = `${productUrl}${variant ? `?variant=${variant.id}` : ''}`;
          window.history.replaceState({}, '', newUrl);
        }

        this.replaceContent(['price'], sectionId, html);

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId: this.sectionId,
            html,
            variant,
          },
        });
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.error('Error in renderProductInfo:', error);
      }
    }

    addBtnText(disable, text, btnElement) {
      if (!btnElement) return;

      btnElement.disabled = disable;

      const span = btnElement.querySelector('span');
      if (!span) return;

      if (disable) {
        if (text) {
          span.textContent = text;
        }
      } else {
        span.textContent = window.variantStrings.addToCart;
      }
    }

    updateVariantInputs(variantId) {
      document
        .querySelectorAll(`#product-form-${this.sectionId}, #product-form-installment-${this.sectionId}`)
        .forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    replaceContent(selectors, sectionId, html) {
      selectors.forEach((selector) => {
        const targetSelector = `[data-${selector}-${sectionId}]`;
        const target = document.querySelector(targetSelector);
        const source = html.querySelector(targetSelector);
        if (target && source) {
          target.innerHTML = source.innerHTML;
        }
      });
    }
  }

  customElements.define('variant-selects', VariantSelects);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-product"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    observer = undefined;

    constructor() {
      super();
    }

    connectedCallback() {
      this.initializeRecommendations(this.dataset.productId);
    }

    initializeRecommendations(productId) {
      this.observer?.unobserve(this);
      this.observer = new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          this.loadRecommendations(productId);
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      this.observer.observe(this);
    }

    loadRecommendations(productId) {
      fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations?.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            // Related Product Swiper
            new Swiper(".related-product-swiper", {
              loop: false,
              spaceBetween: 16,
              slidesPerView: 'auto',
              slidesOffsetBefore: 16,
              slidesOffsetAfter: 16,
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
              },
              breakpoints: {
                768: { slidesPerView: 'auto', spaceBetween: 20, slidesOffsetBefore: 0, slidesOffsetAfter: 0 },
                992: { slidesPerView: 4, spaceBetween: 30 },
                1280: { slidesPerView: 4, spaceBetween: 40 },
                1366: { slidesPerView: 4, spaceBetween: 60 },
                1600: { slidesPerView: 4, spaceBetween: 80 },
              }
            });
          } else {
            this.closest('.related-product-section').remove();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
  

  } catch(e) { console.error(e); }
})();
})();
